export default 'https://tme.understood.org/assets/global_intro.en.9326ae05.vtt'